function degsToRads(degrees) {
  return degrees * (Math.PI / 180);
}



export default degsToRads;